import Header from './components/Header'
import Footer from './components/Footer'
import AppRouter  from './router';
import './App.css';

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function App() {
  const location = useLocation();
  useEffect(() => {
    // 只有存在 _hmt 且处于生产环境时才执行上报（双重保障）
    if (process.env.NODE_ENV === 'production' && typeof window._hmt !== 'undefined') {
      window._hmt.push(['_trackPageview', location.pathname + location.search]);
    }
  }, [location]);

  return (
    <div className="App">
      <Header />      
      <AppRouter/>
      <Footer />
    </div>
  );
}

export default App;
